import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperClass } from "swiper/types";

import { ProductAvailabilityCity } from "@/api/generatedTypes";

import { CityStores } from "./CityStores";
import { CitySwitcher } from "./CitySwitcher";
import styles from "./ProductAvaliability.module.scss";

interface ProductAvaliabilityProps {
  availability: ProductAvailabilityCity[];
  className?: string;
  autoHeight?: boolean;
}

interface City {
  id: string;
  city: string;
}

const ProductAvaliability = ({
  availability,
  className = "",
  autoHeight = true,
}: ProductAvaliabilityProps) => {
  const cities = availability.map((item) => ({
    id: item.city,
    city: item.city,
  }));

  const sortedCities = cities.sort(sortFunction);

  const sortedStores = [...availability].sort(sortFunction);

  const [activeCity, setActiveCity] = useState(sortedCities?.[0].city);

  const swiperRef = useRef<SwiperClass | null>(null);

  const setProperSlide = (index: number) => {
    if (!swiperRef.current) return;

    swiperRef.current.slideTo(index, 250);
  };

  return (
    <div className={className}>
      <CitySwitcher
        cities={sortedCities}
        activeCity={activeCity}
        setActiveCity={setActiveCity}
        setProperSlide={setProperSlide}
      />
      <Swiper
        slidesPerView={1}
        touchReleaseOnEdges={true}
        spaceBetween={8}
        autoHeight={autoHeight}
        onSlideChange={(swiper) => {
          setActiveCity(sortedCities?.[swiper.activeIndex].city);
        }}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {sortedStores.map((city) => (
          <SwiperSlide key={city.city} className={styles.slide}>
            <CityStores stores={city.stores} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const citiesOrder = ["Интернет магазин", "Москва", "Санкт-Петербург", "Казань"];

const sortFunction = (
  a: ProductAvailabilityCity | City,
  b: ProductAvailabilityCity | City
) => {
  const aPosition = citiesOrder.findIndex((item) => item === a.city);
  const bPosition = citiesOrder.findIndex((item) => item === b.city);
  return aPosition - bPosition;
};

export default ProductAvaliability;
